export enum EModalName {
  uploadManagerMobile = 'upload-manager-modal-mobile',
  newComponent = 'new-component-modal',
  connectStreamlabsModal = 'connect-streamlabs-modal',
  createScene = 'create-scene-modal',
  projectDeleteConfirmation = 'project-delete-confirmation',
  sceneDeleteConfirmation = 'scene-delete-confirmation',
  RTMPInfoModal = 'rtmp-info-modal',
  codeEditor = 'code-editor-modal',
  unsavedChangeConfirmation = 'unsaved-change-modal',
  checkoutMini = 'checkout-mini',
  cancelSubscriptionConfirmation = 'cancel-subscription-confirmation',
  switchPlan = 'switch-plan',
  updatePaymentMethod = 'update-payment-method',
  disconnectSLConfirmation = 'disconnect-sl-confirmation',
  disconnectSLIDConfirmation = 'disconnect-slid-confirmation',
  createEditProject = 'create-edit-project',
  modalContainer = 'modal-container',
  adminUserDetails = 'admin-user-details',
  themeLibrary = 'theme-library',
  transitionLibrary = 'transition-library',
  themeResetConfirmation = 'theme-reset-confirmation',
  themeApplyConfirmation = 'theme-apply-confirmation',
  AdminCancelSubscriptionConfirmation = 'admin-cancel-subscription-confirmation',
  AdminRemoveSubscriptionConfirmation = 'admin-remove-subscription-confirmation',
  AdminRefundTransactionConfirmation = 'admin-refund-transaction-confirmation',
  AdminRemovePaymentMethodConfirmation = 'admin-remove-payment-method-confirmation',
  feedback = 'feed-back-modal',
  streamTips = 'stream-tips-modal',
  videoPlayer = 'video-player',
  terms = 'terms',
  changeOfTerms = 'change-of-terms',
  streamLabel = 'stream-label',
  disconnectPlatformConfirmation = 'disconnect-platform-confirmation',
  platform = 'edit-platform',
  streamInfo = 'stream-info',
}
